import { styled } from 'styled-components'

import { Colors } from '@b-stock/fe-core/design-system'

import {
  CELL_COLUMN_BORDER_WIDTH,
  CELL_SIDE_PADDING,
  GAP_WIDTH,
  WIDE_FORM_WIDTH,
} from '../../getActionPanelWidth'
import { PanelIconButton } from '../../ui'

/**
 * The inline bid overlay, covering the collapsed panel on its own row.
 *
 * `visibility` rather than unmounting when the row scrolls out of view, so it
 * returns on scrolling back into view.
 */
export const OverlayPanel = styled.div<{ $isRowVisible: boolean }>`
  --action-form-width: ${WIDE_FORM_WIDTH}px;

  align-items: center;
  background: ${Colors.Semantic.Neutral.white};
  border-left: 2px solid ${Colors.Semantic.Neutral.medium_grey};
  border-right: ${CELL_COLUMN_BORDER_WIDTH}px solid transparent;
  display: flex;
  gap: ${GAP_WIDTH}px;
  padding: 0.5rem ${CELL_SIDE_PADDING}px;
  visibility: ${(o) => (o.$isRowVisible ? 'visible' : 'hidden')};
`

export const CancelButton = styled(PanelIconButton)`
  flex-shrink: 0;
`
